import { useContext } from 'react';

import { ViewportContext } from '../providers';

export const useViewportDimensions = () => {
  return useContext(ViewportContext).dimensions;
};
